import React from 'react';
import {get} from 'lodash';
import axios from 'axios';
import Waypoint from 'react-waypoint';
import PropTypes from 'prop-types';

import {metaLoading} from '../lib/helpers';
import Loading from './Loading';

class CursorBasedList extends React.Component {
  static propTypes = {
    tableClass: PropTypes.string,
    fetchData: PropTypes.func,
    renderItems: PropTypes.func
  };

  state = {
    ...metaLoading,
    shouldFetch: true,
    pageNumber: 0,
    cursors: [],
    items: []
  }

  fetchInitialPage = () => {
    if(this.state.shouldFetch) {
      this.setState({ shouldFetch: false }, () => this.fetchPage(0))
    }
  }

  fetchPage = (pageNumber) => {
    if (!this.state.meta.isLoading) {
      this.setState({
        pageNumber: pageNumber,
        meta: { isLoading: true }
      }, () => this.props.fetchData(this.state.cursors[pageNumber], this.loadPage))
    }
  }

  loadPage = (items, cursor) => {
    this.setState((prevState) => {
      const updatedCursors = [...prevState.cursors]
      updatedCursors[prevState.pageNumber + 1] = cursor
      return {
        items: items,
        cursors: updatedCursors,
        shouldFetch: false,
        meta: {
          isLoading: false
        }
      }
    })
  }

  render () {
    const { pageNumber, cursors, items } = this.state
    const canGoNext = !!(cursors[pageNumber + 1])
    const canGoPrevious = pageNumber > 0

    return (
      <React.Fragment>
        <Waypoint onEnter={this.fetchInitialPage}>
          <div className={`Table ${this.props.tableClass}`}>
            {this.props.children}
            <Loading isLoading={get(this.state, 'shouldFetch')}>
              {this.props.renderItems(items)}
              {items.length == 0 && <div className='Table__row'>
                <div className='Table__col'>
                  {pageNumber > 0 ? 'No more results' : 'Nothing to show yet'}
                </div>
              </div>}
            </Loading>
          </div>
        </Waypoint>
        <div className='Pagination'>
          <div className='Pagination__right'>
            <button
              className='Button Button--uniform'
              disabled={!canGoPrevious}
              onClick={() => this.fetchPage(pageNumber - 1)}
            >
              Previous
            </button>
            <button
              className='Button Button--uniform'
              disabled={!canGoNext}
              onClick={() => this.fetchPage(pageNumber + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export const loadViaApi = (endpoint) => {
  return (cursor, callback) => {
    axios.get(
      endpoint, { params: { from: cursor } }
    ).then((res) => {
      const data = get(res, 'data')
      if (res.status == 200 && data) {
        callback(data.transactions || [], data.cursor)
      }
    })
  }
}

export default CursorBasedList
